import { render, staticRenderFns } from "./ProductBottomIcons.vue?vue&type=template&id=7e2907cc&"
import script from "./ProductBottomIcons.vue?vue&type=script&lang=js&"
export * from "./ProductBottomIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports